export class AuthConstants {
    public static GrantType = "grant_type";
    public static ExternalAuthUrl = "api/Account/login";
    public static LoginPath = "/auth";
    public static FederatedUrlCodePath = "api/Account/GetAuthCodeUrl/";
    public static FederatedLoginPath="api/Account/GetFederatedToken";
    public static ExternalUserTypeParam="External";
    
  }
  